import IMedicalFormElementProps from "../types/IMedicalFormElement";
import { ComposedGeneralMedicalQuestions } from "./ComposedGeneralMedicalQuestions";
import { diabeticFormQuestions } from "./ComposedDiabeticMedicalQuestions";
import { pacemakerFormQuestions } from "./ComposedPacemakerMedicalQuestions";
import { radiationFormQuestions } from "./ComposedRadiationMedicalQuestions";

/** The fully composed questions for the combined medical step, preserving the existing question set. */
export const ComposedAllMedicalQuestions: React.FC<IMedicalFormElementProps>[] = [
  ...ComposedGeneralMedicalQuestions,
  ...pacemakerFormQuestions,
  ...radiationFormQuestions,
  ...diabeticFormQuestions
];

export default ComposedAllMedicalQuestions;
